const sortRoutes = [
  {
    path: '/sort',
    name: 'sort',
    component: () => import('@/views/sort/sort'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/goods-detail',
    name: 'goods-detail',
    component: () => import('@/views/sort/goods-detail'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/knowledge-goods',
    name: 'knowledge-goods',
    component: () => import('@/views/sort/knowledge-goods'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  }
]

export default sortRoutes
